module.exports = __webpack_public_path__ + "img/a-019.prt.b266dd20.jpg";